import { RQ } from 'utils';

export default {
  getInfo: async function () {
    let self = this;
    let d = await RQ.mall.get('/api/h5/goodsApi/getGoodsDetail', { goodsId: self.goodsId }, {
      enterprise: '00'
    });
    if (d && d.code == 0) {
      self.info = d.data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/module/app/gooddetail/action.js